import { ComponentButton } from './ComponentButton';
import { ReloadButton as ReloadButtonType } from '@/schemas/sceneDataSchema';
import useAnalytics, { eventName } from '@/hooks/use-analytics';

export const ReloadButton = ({ component }: { component: ReloadButtonType }) => {
  const { trackClick } = useAnalytics();

  const onClick = () => {
    trackClick(eventName(component.id), { button_type: component.type });
    location.replace(location.origin);
  };

  return (
    <ComponentButton
      onClick={onClick}
      component={component}
      type='button'
    />
  );
};
